<div id="vex-splash-screen">
    <img height="70" width="70" loading="eager" src="assets/img/logo/logo.svg" />
    <div class="vex-splash-screen-loader"></div>
</div>
<router-outlet></router-outlet>